import { render, staticRenderFns } from "./linkArticlesToShop.vue?vue&type=template&id=3c061947&scoped=true&"
import script from "./linkArticlesToShop.vue?vue&type=script&lang=js&"
export * from "./linkArticlesToShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c061947",
  null
  
)

export default component.exports